import { all, takeLeading, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR, SUCCESS } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { retrieveFromLocalStorage, saveToLocalStorage } from '../../utils/util';

import { requestSavePreference, requestViewAllPreferences, requestSavePreferences } from './preference.actions';
import {
  getSavePreferenceRequest,
  getViewAllPreferencesRequest,
  getSavePreferencesRequest,
} from './preference.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';

export function* performSavePreferenceRequest({ payload }) {
  const { preference, onSuccess } = payload;

  try {
    yield put(addSpinner('Saving preference'));

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');
    const [endpoint, options] = getSavePreferenceRequest({
      ...preference,
      partyExternalReference: personExternalReference,
    });

    yield call(axios, endpoint, options);

    yield put(requestViewAllPreferences({ onSuccess }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Saving preference'));
  }
}

export function* watchForSavePreferenceRequest() {
  yield takeLeading(requestSavePreference.type, performSavePreferenceRequest);
}

export function* performViewAllPreferencesRequest({ payload }) {
  const { onSuccess } = payload;

  try {
    yield put(addSpinner('Retrieving preferences'));

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');
    const [endpoint, options] = getViewAllPreferencesRequest(personExternalReference);

    const { data } = yield call(axios, endpoint, options);

    yield call(saveToLocalStorage, 'preferences', data.shortcutPreferences);

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving preferences'));
  }
}

export function* watchForViewAllPreferencesRequest() {
  yield takeLeading(requestViewAllPreferences.type, performViewAllPreferencesRequest);
}

export function* performSavePreferencesRequest({ payload }) {
  const { input } = payload;

  try {
    yield put(addSpinner());

    const [endpoint, options] = getSavePreferencesRequest(input);

    const { data } = yield call(axios, endpoint, options);

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));

    yield put(requestViewAllPreferences());
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner());
  }
}

export function* watchForSavePreferencesRequest() {
  yield takeLeading(requestSavePreferences.type, performSavePreferencesRequest);
}

export default function* preferenceSaga() {
  yield all([watchForSavePreferenceRequest(), watchForViewAllPreferencesRequest(), watchForSavePreferencesRequest()]);
}
